module.exports = __webpack_public_path__ + "static/media/Hillary_online_world_real_world_video_cover.fee56cc4.jpg";